import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NeuronDetailSheet = ({ neuron, onClose }) => {
    const { t } = useTranslation();
    if (!neuron) return null;

    return (
        <>
            <div 
                className="fixed inset-0 bg-black/60 z-50 animate-fadeIn"
                onClick={onClose}
            ></div>
            <div className="fixed bottom-0 left-0 right-0 bg-gray-800 border-t border-indigo-500/50 rounded-t-2xl shadow-2xl p-6 z-50 animate-slide-up">
                <div className="flex items-center mb-4">
                    <div className="p-3 bg-indigo-500/20 rounded-full mr-4">
                        <LucideIcons.BrainCircuit size={24} className="text-indigo-400" />
                    </div>
                    <div>
                        <h3 className="text-lg font-bold text-white">{t('neuronDetailSheet.title')}</h3>
                        <p className="text-xs text-gray-400 truncate">{t('neuronDetailSheet.id', { id: neuron.id })}</p>
                    </div>
                </div>
                <div className="space-y-3 text-sm">
                    <div className="flex justify-between items-center">
                        <span className="text-gray-400">{t('neuronDetailSheet.content')}:</span>
                        <span className="text-white font-semibold text-right">"{neuron.content}"</span>
                    </div>
                    <div className="flex justify-between items-center">
                        <span className="text-gray-400">{t('neuronDetailSheet.contributor')}:</span>
                        <span className="text-white font-semibold">{neuron.userName || t('neuronDetailSheet.anonymous')}</span>
                    </div>
                    <div className="flex justify-between items-center">
                        <span className="text-gray-400">{t('neuronDetailSheet.souls')}:</span>
                        <span className="text-purple-400 font-bold">{neuron.souls || 0}</span>
                    </div>
                </div>
                <button
                    onClick={onClose}
                    className="w-full mt-6 bg-gray-700 hover:bg-gray-600 text-white font-bold py-3 px-6 rounded-lg transition-colors"
                >
                    {t('neuronDetailSheet.close')}
                </button>
            </div>
        </>
    );
};

export default NeuronDetailSheet;
